import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { GlobalSearchService } from '../../services/globalsearchservice.service'
import { PrintService } from '../../services/print.service'
import { PaymentsService } from '../../services/payments.service'
import { OrdersService } from '../../services/orders.service'
import { CustomerService } from '../../services/customer.service'

@Component({
	selector: 'app-matchin-documents',
	templateUrl: './matchin-documents.component.html',
	styleUrls: ['./matchin-documents.component.scss']
})
export class MatchinDocumentsComponent implements OnInit {
	@Input() data: any = [];
	filename = 'matching_documents';
	sending = false;
	fetching: any = false;
	user: any = false;
	allowed_allocate = false;
	customer_data: any = false;
	expandedDebtorno: string | null = null;
	loadingTransactions = false;

	constructor(private ordersService: OrdersService, public customerService: CustomerService, public paymentsService: PaymentsService, private globalSearchService: GlobalSearchService, private printService: PrintService) {}
	@ViewChild('print_table') printtable: ElementRef;

	ngOnInit(): void {
		this.globalSearchService.user.subscribe(r => {
			this.user = r;
			switch(this.user.user.user_group) {
			case '1':
			case '15':
				this.allowed_allocate = true;
				break
			default:
				this.allowed_allocate = false;
				break;
			}
		});

	}
	export () {
		this.globalSearchService.exportJsonToExcel(this.data, 'MatchingDocuments');
	}

	autoAllocateMatching(trans: any) {
		if (this.fetching) {
			this.fetching.unsubscribe();
		}
		this.fetching = this.paymentsService.autoAllocMatchingDocument(trans).subscribe({
			next: () => {
				this.customerService.getMatchingDocs().subscribe((results: any) => {
					this.data = results;
				});
				this.globalSearchService.showNotification('Auto-allocate completed successfully.', 'success', 'bottom', 'right');
			},
			error: (err) => {
				const msg = err?.error?.message || err?.message || 'Auto-allocate failed.';
				this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'right');
			}
		});
	}


	toggleTransactions(d: any) {
		if (this.expandedDebtorno === d.debtorno) {
			this.expandedDebtorno = null;
			return;
		}
		this.loadingTransactions = true;
		this.customerService.getDebtor(d.debtorno).subscribe({
			next: (r: any) => {
				this.customer_data = r;
				this.expandedDebtorno = d.debtorno;
				this.loadingTransactions = false;
			},
			error: () => {
				this.loadingTransactions = false;
			}
		});
	}

	closeTransactions() {
		this.expandedDebtorno = null;
	}

	exportPdf() {
		this.sending = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Matching Receivables',
			subtitle:' created '+today.toLocaleString()
		}

		this.printService.pdf(data).subscribe( (result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.sending = false;

		});
	}
	exportXls() {
		this.sending = true;
		const today = new Date();
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Matching Receivables',
			subtitle:' created '+ today.toLocaleString()
		}

		this.printService.xls(data).subscribe( (result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.sending = false;
		});
	}
}
